import script from "./ToolContextMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./ToolContextMenu.vue?vue&type=script&setup=true&lang=js"

import "./ToolContextMenu.vue?vue&type=style&index=0&id=79dd7ce9&lang=scss"

const __exports__ = script;

export default __exports__